import { Component, OnInit } from '@angular/core';

import { ComunicadosService } from '../../comunicados/comunicados.service';
import { Comunicado } from '../../base/vo/comunicado';

@Component({
    selector: 'app-ultimos-comunicados',
    templateUrl: './ultimos-comunicados.component.html',
    styleUrls: ['./ultimos-comunicados.component.css']    
})
export class UltimosComunicadosComponent implements OnInit {

    public comunicados: Comunicado[] = [];

    constructor(private comunicadosService: ComunicadosService) { }

    ngOnInit() {
        this.buscarUltimosComunicados();
    }

    private buscarUltimosComunicados(){
        this.comunicadosService.buscarUltimosComunicados()
            .subscribe(
                res=> {
                    this.comunicados = res.data.list;
                },
                err => {
                    console.log('Mensagem de Erro');
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/ultimos-comunicados/ultimos-comunicados.component.ts